import React from 'react';
import { CTAButton } from './CTAButton';
export function RealResults() {
  return <section className="bg-primary-emerald py-[100px] px-5" data-id="element-482">
      <div className="max-w-[1040px] mx-auto" data-id="element-483">
        <div className="text-center mb-16" data-id="element-484">
          <h2 className="font-serif text-[36px] md:text-[44px] text-cream-light mb-4" data-id="element-485">
            What Happened After They Started
          </h2>
          <p className="font-sans text-[16px] text-cream-light/70" data-id="element-486">
            Real people. Real incomes. Real debt. Real results.
          </p>
        </div>

        {/* Real people visual — Sarah, Carlos, Maria */}
        <div className="mb-16 max-w-[780px] mx-auto rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.3)] border border-gold-accent/15" data-id="element-487">
          <img src="https://cdn.magicpatterns.com/uploads/ezVctqabkEEhN21L1DZ9RD/heylloyd-image-1774831491121.png" alt="Real people using The Debt-Free System — Sarah tracking her budget, Carlos hitting $1,000 in savings, Maria making her negotiation call" className="w-full h-auto block" data-id="element-488" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-489">
          {/* Card 1 */}
          <div className="bg-white/5 border border-gold-accent/20 rounded-xl p-[40px_36px] transition-all duration-300 hover:bg-white/10 hover:border-gold-accent/50 flex flex-col" data-id="element-490">
            <h3 className="font-serif text-[22px] text-gold-accent mb-1" data-id="element-491">
              Sarah, 34
            </h3>
            <p className="font-sans text-[13px] text-cream-light/60 mb-6" data-id="element-492">
              $52K/year · $38,200 total debt · Started: 15 months ago
            </p>
            <p className="font-sans italic text-[17px] text-cream-light leading-[1.9] mb-8 flex-grow" data-id="element-493">
              "I used to dread Sunday nights. Genuinely dread them — like a
              physical sensation in my chest. I did the Gas Moment math every
              week for four years.
              <br data-id="element-494" />
              <br data-id="element-495" />
              Fifteen months after starting the system: debt-free.
              <br data-id="element-496" />
              <br data-id="element-497" />
              My Sunday Check-In takes 12 minutes now. My Emergency Shield has
              $3,200. I opened a Fidelity account last month for the first time
              in my adult life."
            </p>
            <div className="inline-block bg-gold-accent text-primary-dark font-sans font-bold text-[12px] px-4 py-2 rounded-full self-start" data-id="element-498">
              Debt-free in 15 months ✓
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white/5 border border-gold-accent/20 rounded-xl p-[40px_36px] transition-all duration-300 hover:bg-white/10 hover:border-gold-accent/50 flex flex-col" data-id="element-499">
            <h3 className="font-serif text-[22px] text-gold-accent mb-1" data-id="element-500">
              Carlos, 27
            </h3>
            <p className="font-sans text-[13px] text-cream-light/60 mb-6" data-id="element-501">
              $38K/year · $17,200 in debt · $0 in savings
            </p>
            <p className="font-sans italic text-[17px] text-cream-light leading-[1.9] mb-8 flex-grow" data-id="element-502">
              "The 70/10/20 split changed everything. I kept thinking I didn't
              make enough to save. The system proved me wrong.
              <br data-id="element-503" />
              <br data-id="element-504" />
              Credit card: gone in 5 months.
              <br data-id="element-505" />
              Student loans: on track for 22 months.
              <br data-id="element-506" />
              Emergency Shield: crossed $1,000 four months ago.
              <br data-id="element-507" />
              <br data-id="element-508" />I have never — not once in my adult life — had $1,000 in
              savings. I haven't touched it."
            </p>
            <div className="inline-block bg-gold-accent text-primary-dark font-sans font-bold text-[12px] px-4 py-2 rounded-full self-start" data-id="element-509">
              $1,000 saved — first time ever ✓
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white/5 border border-gold-accent/20 rounded-xl p-[40px_36px] transition-all duration-300 hover:bg-white/10 hover:border-gold-accent/50 flex flex-col" data-id="element-510">
            <h3 className="font-serif text-[22px] text-gold-accent mb-1" data-id="element-511">
              Maria
            </h3>
            <p className="font-sans text-[13px] text-cream-light/60 mb-6" data-id="element-512">
              One Sunday · Four phone calls · $2,100/year saved
            </p>
            <p className="font-sans italic text-[17px] text-cream-light leading-[1.9] mb-8 flex-grow" data-id="element-513">
              "I made four calls. Three credit cards, one car insurance. Chapter
              5 covered all of them.
              <br data-id="element-514" />
              <br data-id="element-515" />
              $2,100 per year that used to disappear into interest. Now it stays
              in my account.
              <br data-id="element-516" />
              <br data-id="element-517" />
              I'm genuinely angry nobody told me I could just call and ask."
            </p>
            <div className="inline-block bg-gold-accent text-primary-dark font-sans font-bold text-[12px] px-4 py-2 rounded-full self-start" data-id="element-518">
              $2,100/year from calls alone ✓
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-16" data-id="element-519">
          <CTAButton subText="Join Sarah, Carlos, and Maria · Start tonight" data-id="element-520">
            I WANT RESULTS LIKE THESE — $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}